export function BackShirtIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.01682 2.88366L6.66682 1.66699C6.66682 1.66699 8.33346 2.50033 10.0001 2.50033C11.6668 2.50033 13.3335 1.66699 13.3335 1.66699L16.9835 2.88366C17.3607 3.00932 17.6805 3.26567 17.8853 3.60644C18.09 3.94722 18.1663 4.34996 18.1002 4.74199L17.6168 7.63366C17.5851 7.82942 17.4846 8.00745 17.3334 8.13575C17.1822 8.26406 16.9901 8.33423 16.7918 8.33366H15.0002V16.667C15.0002 17.109 14.8246 17.5329 14.512 17.8455C14.1994 18.1581 13.7755 18.3337 13.3335 18.3337H6.66682C5.75016 18.3337 5.00016 17.5837 5.00016 16.667V8.33366H3.20849C3.01017 8.33423 2.81816 8.26406 2.66694 8.13575C2.51572 8.00745 2.41522 7.82942 2.38349 7.63366L1.90016 4.74199C1.83405 4.34996 1.91027 3.94722 2.11503 3.60644C2.3198 3.26567 2.63964 3.00932 3.01682 2.88366Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
